import { render } from "./AccordionItem2.vue?vue&type=template&id=6f8b82ef"
import script from "./AccordionItem2.vue?vue&type=script&lang=js"
export * from "./AccordionItem2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__